/*
 * @Date         : 2021-03-29 11:17:51
 * @LastEditors: zhangxu
 * @LastEditTime: 2022-04-27 14:36:59
 * @FilePath: /daodao-biz-front/src/request/index.ts
 */
import { vm } from '@/main'
import storage from '@/shared/storage'
import Cookie from '@/shared/cookie'
import service from './base'
import { WMZY_TOKEN } from '@/config/constant.cfg'

import { TrialFormReq, ReSetPwdFormType } from '@/container/login/types'
import { Common } from '@/interface/common.interface'

const basePath = '/api/v1'

const basePathV2 = '/api/v2'

// 添加新员工
export async function addStaff(params?: any) {
  return await service({ url: `${basePath}/addStaff`, method: 'POST', params })
}

// 删除候选人记录
export async function delCandidateRecord(params?: any) {
  return await service({ url: `${basePath}/delCandidateRecord`, method: 'POST', params })
}

// 删除员工
export async function delStaffRecord(params?: any) {
  return await service({ url: `${basePath}/delStaffRecord`, method: 'POST', params })
}

// 获取候选人列表
export async function getCandidateList(params?: any) {
  return await service({ url: `${basePath}/getCandidateList`, method: 'POST', params })
}

// 获取候选人列表
export async function getCandidateListV2(params?: any) {
  return await service({ url: `${basePathV2}/getCandidateList`, method: 'POST', params })
}

// 获取员工列表
export async function getStaffList(params?: any) {
  return await service({ url: `${basePath}/getStaffList`, method: 'POST', params })
}

// 获取员工列表
export async function getStaffListV2(params?: any) {
  return await service({ url: `${basePathV2}/getStaffList`, method: 'POST', params })
}

// 按用户名或手机号搜索候选人
export async function searchPRecord(params?: any) {
  return await service({ url: `${basePath}/searchPRecord`, method: 'POST', params })
}

// 转为员工
export async function transferToStaff(params?: any) {
  return await service({ url: `${basePath}/transferToStaff`, method: 'POST', params })
}

// 获取评测地址（招生中心用）
export async function getEvaluation(params?: any) {
  return await service({ url: `${basePath}/getEvaluation`, method: 'POST', params })
}

// 获取评测地址（人才测评用）
export async function getEvaluationV2(params?: any) {
  return await service({ url: `${basePath}/getEvaluationV2`, method: 'POST', params })
}

// 创建活动
export async function createActivity(params?: any) {
  return await service({ url: `${basePath}/createActivity`, method: 'POST', params })
}

// 获取历史短信提醒记录
export async function getLastSMSRemind(params?: any) {
  return await service({ url: `${basePath}/getLastSMSRemind`, method: 'POST', params })
}

// 获取发送短信的模板
export async function getSMSTemplate(params?: any) {
  return await service({ url: `${basePath}/getSMSTemplate`, method: 'POST', params })
}

// 发送短信
export async function sendSMSRemind(params: any) {
  return await service({ url: `${basePath}/sendSMSRemind`, method: 'POST', params })
}

// 添加跟进记录
export async function addTraceRecord(params?: any) {
  return await service({ url: `${basePath}/addTraceRecord`, method: 'POST', params })
}

// 获取待评估的客户列表
export async function getEvaluationList(params?: any) {
  return await service({ url: `${basePath}/getEvaluationList`, method: 'POST', params })
}

// 获取历史跟进列表
export async function getTraceList(params?: any) {
  return await service({ url: `${basePath}/getTraceList`, method: 'POST', params })
}

// 根据名字 或手机号或来源搜索，三个条件不组合
export async function searchEvaluation(params?: any) {
  return await service({ url: `${basePath}/searchEvaluation`, method: 'POST', params })
}

// 查询统计数据
export async function statistics(params?: any) {
  return await service({ url: `${basePath}/statistics`, method: 'POST', params })
}

// 转为学员
export async function transferClient(params?: any) {
  return await service({ url: `${basePath}/transferClient`, method: 'POST', params })
}

// 登录
export async function login(params: { mobilePhone: string; smsCode: string }) {
  const data = await service({ url: `${basePath}/login`, method: 'POST', params })
  const { header, rsp } = data
  const { permission, user } = rsp
  storage.set('account', header)
  // storage.set('permission', permission)
  storage.set('user', user)

  // 设置在填报志愿时跳转到完美志愿时需要使用到的 userId 及 jwtToken 数据, 过期时间为 7 天.
  Cookie.set(WMZY_TOKEN.cookie_token_key, header?.ext[WMZY_TOKEN.sourceTokenKey], { expires: 7 })
  Cookie.set(WMZY_TOKEN.cookie_user_id_key, user.userId, { expires: 7 })
  Cookie.set(WMZY_TOKEN.cookie_domain, header?.ext['channel'], { expires: 7 })

  vm.$store.commit('setLoginInfo', {
    account: header,
    permission,
    user,
  })
  return rsp
}

// 退出登录
export async function logout(params?: any) {
  await service({ url: `${basePath}/logout`, method: 'POST', params })
  storage.delete('user')
  return vm.$store.commit('clearLoginInfo')
}

/**
 * 根据提供的手机号码发送短信.
 *
 * type 值定义如下:
 *
 * 1 - 机构运营帐号登录.
 * 2 - 机构帐号修改手机号.
 * 3 - 机构客户登录.
 * 4 - 机构修改密码.
 */
export async function sendSMSCode(params: { mobilephone: string; type?: number }) {
  return await service({ url: `${basePath}/sendSMSCode`, method: 'POST', params })
}

// 转付费客户列表
export async function getClientList(params?: any) {
  return await service({ url: `${basePath}/getClientList`, method: 'POST', params })
}

// 获取行业信息
export async function getIndustryList(params?: any) {
  return await service({ url: `${basePath}/getIndustryList`, method: 'GET', params })
}

// 获取职位信息
export async function getPositionList(params?: any) {
  return await service({ url: `${basePath}/getPositionList`, method: 'GET', params })
}

// 获取职位信息
export async function getAreaList(): Promise<Common.AreaResult> {
  return await service({ url: `${basePath}/getAreaList`, method: 'GET' })
}

// 获取评测列表
export async function etopics(params?: any) {
  return await service({ url: `${basePath}/etopics`, method: 'POST', params })
}

// 添加客户
export async function addClient(params?: any) {
  return await service({ url: `${basePathV2}/addClient`, method: 'POST', params })
}

// 查询客户
export async function getClient(params?: any): Promise<{
  client: Common.Client
}> {
  return await service({ url: `${basePath}/getClient`, method: 'POST', params })
}

// 查询客户2
export async function getEvaluators(params?: any): Promise<{
  client: Common.Client
  evaluatorId: string
}> {
  return await service({ url: `${basePathV2}/getEvaluators`, method: 'POST', params })
}

// 修改客户信息
export async function updateClient(params?: any) {
  return await service({ url: `${basePath}/updateClient`, method: 'POST', params })
}

// 修改客户信息
export async function updateEvaluator(params?: any) {
  return await service({ url: `/api/v1/updateClient`, method: 'POST', params })
}

// 变更评估主题
export async function changeEvaluation(params?: any) {
  return await service({ url: `${basePath}/changeEvaluation`, method: 'POST', params })
}

// 获取列表集合页
export async function getReportList(params?: any) {
  return await service({ url: `${basePath}/getReportList`, method: 'POST', params })
}

// 人才评估-查看单个员工资料信息
export async function getStaff(params?: any) {
  return await service({ url: `${basePath}/getStaff`, method: 'POST', params })
}

// 人才评估-查看单个候选人资料信息
export async function getCandidate(params?: any) {
  return await service({ url: `${basePath}/getCandidate`, method: 'POST', params })
}

// 人才评估-更新员工资料
export async function updateStaff(params?: any) {
  return await service({ url: `${basePath}/updateStaff`, method: 'POST', params })
}

// 人才评估-员工转为离职
export async function transferToResign(params?: any) {
  return await service({ url: `${basePath}/transferToResign`, method: 'POST', params })
}

// 获取用户信息
export async function getPRecord(params?: any) {
  return await service({ url: `${basePath}/getPRecord`, method: 'POST', params })
}

// 更新用户信息
export async function updatePRecord(params?: any) {
  return await service({ url: `${basePath}/updatePRecord`, method: 'POST', params })
}

export async function getReport(params?: any) {
  return await service({ url: `${basePath}/getReport`, method: 'POST', params })
}

export async function getPersonReport(params?: any) {
  return await service({ url: `${basePathV2}/getPersonReport`, method: 'POST', params })
}

export async function activateOrgUser(params?: any) {
  return await service({ url: `${basePath}/activateOrgUser`, method: 'POST', params })
}

// 获取机构信息
export async function getOrg(params?: any) {
  return await service({ url: `${basePath}/getOrg`, method: 'POST', params })
}

// 获取机构赛道信息
export async function getOrgTracks(params?: any) {
  return await service({ url: `${basePath}/getOrgTracks`, method: 'POST', params })
}

// 获取机构用户信息 /api/v1/getOrgUserInfo
export async function getOrgUserInfo(params?: { userId: number }) {
  return await service({ url: `${basePath}/getOrgUserInfo`, method: 'POST', params })
}

export async function addOrg(params?: any) {
  return await service({ url: `${basePath}/addOrg`, method: 'POST', params })
}

// 编辑机构信息
export async function updateOrg(params?: any) {
  return await service({ url: `${basePath}/updateOrg`, method: 'POST', params })
}

export async function addOrgRole(params?: any) {
  return await service({ url: `${basePath}/addOrgRole`, method: 'POST', params })
}

export async function addOrgUser(params?: any) {
  return await service({ url: `${basePath}/addOrgUser`, method: 'POST', params })
}

export async function getOrgRoleList(params?: any) {
  return await service({ url: `${basePath}/getOrgRoleList`, method: 'POST', params })
}

export async function saveOrgRoleInfo(params: Common.SaveOrgRoleInfoReqParam) {
  return await service({ url: `${basePath}/saveOrgRoleInfo`, method: 'POST', params })
}

export async function getOrgUserList(params?: any) {
  return await service({ url: `${basePath}/getOrgUserList`, method: 'POST', params })
}

export async function getOrgRole(params?: any) {
  return await service({ url: `${basePath}/getOrgRole`, method: 'POST', params })
}

export async function getUserListByMobilePhone(params?: any) {
  return await service({ url: `${basePath}/getUserListByMobilePhone`, method: 'POST', params })
}

export async function getOrgUser(params?: any) {
  return await service({ url: `${basePath}/getOrgUser`, method: 'POST', params })
}

export async function updateOrgUser(params?: any) {
  return await service({ url: `${basePath}/updateOrgUser`, method: 'POST', params })
}

// 启用与停用账号
export async function stopOrgUser(params?: any) {
  return await service({ url: `${basePath}/stopOrgUser`, method: 'POST', params })
}

// 指派状态修改
export async function updateOrgUserAppoint(params?: any) {
  return await service({ url: `${basePath}/updateOrgUserAppoint`, method: 'POST', params })
}
// 公海档案状态修改
export async function updateOrgUserDraw(params?: any) {
  return await service({ url: `${basePath}/updateOrgUserDraw`, method: 'POST', params })
}

// 检测手机号是否已注册
export async function existMobilePhone(params?: any) {
  return await service({ url: `${basePathV2}/existMobilePhone`, method: 'POST', params })
}
// 检测手机号是否已注册2
export async function getClientsByMobile(params?: any) {
  return await service({ url: `${basePath}/getClientsByMobile`, method: 'POST', params })
}

// 获取码表配置
export async function getRefTable(params?: any) {
  return await service({ url: `${basePath}/getRefTable`, method: 'POST', params })
}

/**
 * 获取升学获客与1对1服务列表数据.
 *
 * @param serveModule 服务模块 1--招生评估 2--升学规划
 * @param serveScene 服务场景 1--招生 2--服务
 */
export async function getEnrollmentClientList(params?: any) {
  return await service({ url: `${basePath}/getEnrollmentClientList`, method: 'POST', params })
}

// 查询省份列表.
export async function getLocFilter(params?: any): Promise<Common.ProvinceResult> {
  return await service({ url: `${basePath}/getLocFilter`, method: 'GET', params })
}

/**
 * 获取成绩配置信息.
 * @param enroll_category 高考类型
 * @param enroll_mode 高考模式
 */
export async function getProvinceScoreConf(params?: {
  province_id: string
  enroll_category: number
  enroll_mode: number
}) {
  return await service({ url: `${basePath}/getProvinceScoreConf`, method: 'POST', params })
}

/**
 * 上传图片.
 */
export async function uploadImage(params?: any): Promise<Common.UploadImageRes> {
  return await service({ url: `${basePath}/UploadImage`, method: 'POST', params }, { paramUseData: true })
}

/**
 * 查询所有可选赛道标签.
 */
export async function getTrackList(): Promise<{ list: string[] }> {
  return await service({ url: `${basePath}/getTrackList`, method: 'GET', params: {} })
}

/**
 * 保存登录页试用申请信息.
 */
export async function saveTrialApplication(params: TrialFormReq) {
  return await service({ url: `${basePath}/saveTrialApplication`, method: 'POST', params })
}

/**
 * 重置密码.
 */
export async function resetPassword(params: ReSetPwdFormType) {
  return await service({ url: `${basePath}/resetPassword`, method: 'POST', params })
}

/**
 * @description: 查询 OSS 上传 token 相关参数.
 */
export async function getOSSSTSCredentials(
  params: Common.OSSSTSCredentialsReqParam
): Promise<Common.OSSSTSCredentialsRes> {
  return await service({ url: `${basePathV2}/getOSSSTSCredentials`, method: 'POST', params })
}

/**
 * @description: 创建批量导入任务.
 */
export async function addImportTask(params: Common.AddImportTaskReqParam): Promise<Common.AddImportTaskRes> {
  return await service({ url: `${basePathV2}/addTask`, method: 'POST', params })
}

/**
 * @description: 获取导入任务列表.
 */
export async function getImportTaskList(
  params: Common.GetImportTaskListReqParam
): Promise<Common.GetImportTaskListRes> {
  return await service({ url: `${basePathV2}/getTaskList`, method: 'POST', params })
}
